export default __webpack_public_path__ + "static/media/well2.1fad3dc3.jpg";